<template>
  <v-container fluid class="pa-6" style="background-color: #F4F7FE; min-height: 100vh;">
    <v-row>
      <v-col cols="12" md="8">
        <v-card class="rounded-xl pa-4 elevation-1">
          <v-toolbar flat color="transparent">
            <v-icon color="#4318FF" class="mr-3">mdi-shopping</v-icon>
            <v-toolbar-title class="font-weight-black">Punto de Venta</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="busqueda"
              append-icon="mdi-magnify"
              label="Buscar producto..."
              outlined dense hide-details class="rounded-lg"
            ></v-text-field>
          </v-toolbar>

          <v-data-table :headers="headers" :items="productosFiltrados" :loading="cargando">
            <template v-slot:item.foto="{ item }">
              <div class="d-flex align-center py-2">
                <v-avatar size="45" class="mr-3 list-avatar" color="#F4F7FE">
                   <v-img :src="item ? urlImagen(item.imagen) : ''" />
                </v-avatar>
              </div>
            </template>

            <template v-slot:item.acciones="{ item }">
              <v-btn color="#4318FF" dark small class="rounded-lg" 
                     @click="agregarAlCarrito(item)" :disabled="item.existencia <= 0">
                AGREGAR
              </v-btn>

            
              <v-btn icon small class="ml-2 action-primary" @click="verDetalleProducto(item)">
                <v-icon>mdi-eye-outline</v-icon>
              </v-btn>
            </template>
          </v-data-table>

         
          <v-dialog v-model="mostrarDetalle" max-width="700">
            <v-card>
              <v-row no-gutters>
                <v-col cols="12" md="6" class="pa-4 d-flex align-center justify-center">
                  <v-img :src="selectedProduct && selectedProduct.imagen ? urlImagen(selectedProduct.imagen) : ''" max-width="100%" contain></v-img>
                </v-col>
                <v-col cols="12" md="6" class="pa-4">
                  <v-card-title class="text-h6 font-weight-bold">{{ selectedProduct.nombre }}</v-card-title>
                  <v-card-text>
                    <div class="mb-2"><strong>Código:</strong> {{ selectedProduct.codigo || '-' }}</div>
                    <div class="mb-2"><strong>Precio:</strong> S/ {{ selectedProduct.precioVenta }}</div>
                    <div class="mb-2"><strong>Stock:</strong> {{ selectedProduct.existencia }}</div>
                    <div v-if="selectedProduct.descripcion" class="mb-2"><strong>Descripción:</strong> {{ selectedProduct.descripcion }}</div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="mostrarDetalle = false">Cerrar</v-btn>
                    <v-btn color="#4318FF" dark @click="agregarDesdeDetalle" :disabled="!canAgregarFromDetail">
                      Agregar al carrito
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card class="rounded-xl pa-6 elevation-3" dark color="#4318FF">
          <h3 class="text-h5 font-weight-bold mb-4">Resumen de Venta</h3>
          
          <v-list color="transparent" dense style="max-height: 400px; overflow-y: auto;">
            <v-list-item v-for="(p, i) in carrito" :key="i" class="px-0">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">{{ p.nombre }}</v-list-item-title>
                <v-list-item-subtitle class="white--text">S/ {{ p.precioVenta }} c/u</v-list-item-subtitle>
              </v-list-item-content>
              
              <v-list-item-action class="flex-row align-center">
                <v-btn icon x-small @click="cambiarCantidad(p, -1)" class="white--text">
                  <v-icon>mdi-minus-circle</v-icon>
                </v-btn>
                <span class="mx-2 font-weight-bold text-h6">{{ p.cantidad }}</span>
                <v-btn icon x-small @click="cambiarCantidad(p, 1)" class="white--text">
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
                <v-btn icon small color="error" class="ml-2" @click="quitarDelCarrito(i)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider class="my-4 white"></v-divider>
          
          <div class="d-flex justify-space-between align-center mb-6">
            <span class="text-h6">TOTAL</span>
            <span class="text-h3 font-weight-black">S/ {{ totalVenta.toFixed(2) }}</span>
          </div>

          <v-btn block x-large color="white" light class="rounded-xl font-weight-black" 
                 :loading="cargando" :disabled="carrito.length === 0" @click="finalizarVenta">
            CONFIRMAR VENTA
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import HttpService from "../Servicios/HttpService";
import Utiles from "../Servicios/Utiles";

export default {
  data: () => ({
    busqueda: '',
    cargando: false,
    productos: [],
    carrito: [],
    selectedProduct: {},
    mostrarDetalle: false,
    headers: [
      { text: 'Foto', value: 'foto', sortable: false }, 
      { text: 'Producto', value: 'nombre' },
      { text: 'Precio S/', value: 'precioVenta' },
      { text: 'Stock', value: 'existencia' },
      { text: 'Acción', value: 'acciones', sortable: false }
    ]
  }),
  computed: {
    totalVenta() {
      return this.carrito.reduce((acc, p) => acc + (parseFloat(p.precioVenta) * p.cantidad), 0);
    },
    productosFiltrados() {
      return this.productos.filter(p => p.nombre.toLowerCase().includes(this.busqueda.toLowerCase()));
    },
    canAgregarFromDetail() {
      return this.selectedProduct && this.selectedProduct.existencia > 0;
    }
  },
  mounted() {
    this.obtenerProductos();
  },
  methods: {
    async obtenerProductos() {
      this.cargando = true;
      try {
        const res = await HttpService.obtenerConDatos({ metodo: "obtener" }, "productos.php");
        this.productos = Array.isArray(res) ? res : [];
      } finally { this.cargando = false; }
    },
    agregarAlCarrito(item) {
      const existe = this.carrito.find(p => p.id === item.id);
      if (existe) {
        this.cambiarCantidad(existe, 1);
      } else {
        this.carrito.push({ ...item, cantidad: 1 });
      }
    },
    cambiarCantidad(p, delta) {
      const nuevaCantidad = p.cantidad + delta;
      
      if (nuevaCantidad >= 1 && nuevaCantidad <= p.existencia) {
        p.cantidad = nuevaCantidad;
      }
    },
    quitarDelCarrito(index) {
      this.carrito.splice(index, 1);
    },
    async finalizarVenta() {
      this.cargando = true;
      const datosVenta = {
        id_usuario: localStorage.getItem('idUsuario') || 1,
        nombre_cliente: "Público General",
        total: this.totalVenta,
        total_pagado: this.totalVenta,
        metodo_pago: 'Efectivo',
        productos: this.carrito.map(p => ({
          id: p.id,
          cantidad: p.cantidad,
          precioVenta: p.precioVenta
        }))
      };
      try {
        const res = await HttpService.obtenerConDatos({ metodo: "registrar", datos: datosVenta }, "ventas.php");
        if (res && res.resultado) {
          alert("¡Venta Exitosa! Ticket: " + res.ticket); 
          this.carrito = [];
          await this.obtenerProductos();
        }
      } catch (e) { console.error(e); } finally { this.cargando = false; }
    },
    verDetalleProducto(item) {
      this.selectedProduct = { ...item };
      this.mostrarDetalle = true;
    },
    agregarDesdeDetalle() {
      if (!this.selectedProduct || this.selectedProduct.existencia <= 0) return;
      const existe = this.carrito.find(p => p.id === this.selectedProduct.id);
      if (existe) {
        this.cambiarCantidad(existe, 1);
      } else {
        this.carrito.push({ ...this.selectedProduct, cantidad: 1 });
      }
      this.mostrarDetalle = false;
    },
    urlImagen(imagen) {
      return Utiles.generarURL(imagen, 'productos');
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Ventas.vue